module.exports = __webpack_public_path__ + "static/img/电网.b25698db.png";